export const MR_EXCEEDED_BUDGET = 1;
export const MR_REQUESTED_QUANTITY_ERROR = 2;
export const MR_DELIVERY_TIME_NONCONFORMITY = 3;
export const MR_ADMINISTRATIVE_AFFAIRS = 4;
export const MR_WITHOUT_STOCK = 5;
export const MR_DELIVERY_DATE = 6;
export const MR_POOR_CONDITION_PRODUCTS = 7;
export const MR_WRONG_PRODUCT = 8;
export const MR_MISSING_PRODUCT = 9;
export const MR_OTHER_REASON = 10;